/* eslint-disable brace-style */
/* eslint-disable max-len */
/* eslint-disable no-console */

/**
 * @class SpartaGlobalParamsUtility
 * @description
 * Gets spaParams object to support helpers both during or after build.
 */
class SpartaGlobalParamsUtility {
  constructor() {
    /**
     * Attempt to look up spaParams from widget instance
     */
    this.localSpaParams;
    try {
      if (typeof document !== 'undefined') {
        if (document.currentScript) {
          const widgetName = document.currentScript.getAttribute("widget-name");
          const widgetVersion = document.currentScript.getAttribute("widget-version");
          if (widgetName && widgetVersion) {
            this.localSpaParams = Object.assign(window.spaWidgetParams[widgetName][widgetVersion], {
              isWidget: true,
              language: document.currentScript.parentElement.querySelector('.sparta-widget-container').getAttribute('data-sparta-lang').split('-')[0]
            });
          } else {
            this.localSpaParams = window.spaParams;
          }
        } else {
          this.localSpaParams = window.spaParams;
        }
      }
    } catch (e) {
      console.error('SpartaGlobalParams: Failed to process localSpaParams');
    }
  }
  getSpaParams({
    context = {},
    lookupKey,
    defaultObj = {}
  }) {
    // If context was passed as an array but only containing one item
    let jcrContexts = context;
    if (context.length === 1) {
      jcrContexts = context[0];
    }
    // Else if context is an array with multiple values
    // Note: Params are always added as the last item by platform during build
    else if (context.length > 1) {
      jcrContexts = context.slice(-1).pop();
    }

    // Strings set during helper build
    let globalStrings = jcrContexts && 'data' in jcrContexts && 'root' in jcrContexts.data && 'global' in jcrContexts.data.root ? lookupKey in jcrContexts.data.root.global ? jcrContexts.data.root.global[lookupKey] : jcrContexts.data.root.global : {};

    // If global strings could not be found and spaParams is available, try to get global strings from there
    // This is used when helper is called post page load.
    if (Object.keys(globalStrings).length === 0 && this.localSpaParams) {
      if (lookupKey) {
        globalStrings = this.localSpaParams.global[this.localSpaParams.language][lookupKey] || globalStrings;
      } else {
        globalStrings = this.localSpaParams.global[this.localSpaParams.language] || globalStrings;
      }
    }

    // If global strings are still not set due to environment or missing global object strings
    if (Object.keys(globalStrings).length === 0) {
      if (Object.keys(defaultObj).length > 0) {
        globalStrings = defaultObj;
      } else {
        globalStrings = {};
      }
    }

    // Return our global string object
    return globalStrings;
  }
}

// export new instance of utility
var index = new SpartaGlobalParamsUtility();

export { index as default };
